import {Component, Injectable, Input, OnInit, Pipe, PipeTransform} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import { ProviderModel } from 'src/models/ProviderModel';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {UsersService} from '../../users/service/users.service';

@Injectable()
@Component({
  selector: 'app-delta-volumi-tab',
  templateUrl: './delta-volumi-tab.component.html',
  styleUrls: ['./delta-volumi-tab.component.scss']
})
export class DeltaVolumiTabComponent extends BaseGeneralComponent implements OnInit, PipeTransform {
  selectedIndex: any;
  sectionId: string;
  @Input() reportSection?: boolean;

  providerSelected: ProviderModel;

  constructor(private _Activatedroute: ActivatedRoute,
              private userService: UsersService) {
    super();
    this.sectionId = this.SECTIONS.MONTHLY_ACTUALS;
    this.user = JSON.parse(sessionStorage.getItem('user'));
    _Activatedroute.queryParams.subscribe(params => {
      this.selectedIndex = params['selectedIndex'];
    });
  }

  ngOnInit() {
    this.userService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });

      this.providerSelected = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;
      
  }

  transform(items: any[], field: string, value: string): any[] {
    if (!items) {
      return [];
    }
    if (!field || !value) {
      return items;
    }

    return items.filter(singleItem =>
      singleItem[field].toLowerCase().includes(value.toLowerCase())
    );
  }
}
